import React from 'react';
import { motion } from 'framer-motion';
import { FiStar, FiMessageSquare } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const testimonials = [
  {
    quote: "The CPA inbound calls we receive are leaps and bounds above other networks. Our closing rate jumped 22% in the first month.",
    name: "Michael R.",
    role: "Director of Sales, Tax Relief Co.",
    rating: 5
  },
  {
    quote: "VideoNation's SSDI transfers are highly vetted. It saves our agents from wasting time on unqualified prospects. Highly recommended.",
    name: "Sarah J.",
    role: "Operations Manager, Advocacy Group",
    rating: 5
  },
  {
    quote: "Consistent volume and great quality. The home service leads have been a game changer for our dispatch team's daily metrics.",
    name: "David L.",
    role: "Owner, Regional HVAC Services",
    rating: 5
  }
];

const Testimonials = () => {
  return (
    <section className="py-24 bg-slate-950 px-6 border-t border-white/5">
      <div className="max-w-7xl mx-auto">
        <div className="flex flex-col md:flex-row justify-between items-end mb-16 gap-6">
          <div>
            <h2 className="text-indigo-500 font-bold tracking-widest uppercase text-xs mb-3">Partner Success</h2>
            <h3 className="text-3xl md:text-5xl font-black text-white tracking-tighter">TRUSTED BY ADVERTISERS</h3>
          </div>
          <div className="flex items-center gap-2 bg-white/5 border border-white/10 px-4 py-2 rounded-full">
            <div className="flex text-yellow-500 text-sm">
              {[...Array(5)].map((_, i) => <SafeIcon key={i} icon={FiStar} className="fill-current" />)}
            </div>
            <span className="text-white text-sm font-bold ml-2">4.9/5 Average ROI</span>
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, scale: 0.95 }}
              whileInView={{ opacity: 1, scale: 1 }}
              viewport={{ once: true }}
              transition={{ delay: index * 0.1 }}
              className="bg-gradient-to-b from-slate-900 to-slate-900/50 border border-white/5 p-8 rounded-3xl relative"
            >
              <SafeIcon icon={FiMessageSquare} className="absolute top-8 right-8 text-4xl text-white/5" />
              <div className="flex gap-1 text-yellow-500 mb-6 text-sm">
                {[...Array(testimonial.rating)].map((_, i) => (
                  <SafeIcon key={i} icon={FiStar} className="fill-current" />
                ))}
              </div>
              <p className="text-slate-300 text-lg leading-relaxed mb-8 italic">
                "{testimonial.quote}"
              </p>
              <div className="flex items-center gap-4">
                <div className="w-12 h-12 bg-indigo-900 rounded-full flex items-center justify-center border border-indigo-500/30">
                  <span className="text-indigo-300 font-bold">{testimonial.name.charAt(0)}</span>
                </div>
                <div>
                  <h5 className="text-white font-bold">{testimonial.name}</h5>
                  <p className="text-slate-500 text-xs">{testimonial.role}</p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;